import { clearFlowRunSummary, fetchFlowRunSummary } from 'js/actions/metrics';
import { UseAppDispatchReturnType } from 'js/hooks/useAppDispatch';
import { runSource } from 'js/actions';

export const flowInsightsAPI = (dispatch: UseAppDispatchReturnType) => {
  return {
    fetchFlowRunSummary: async (originNodeId: string, options: any) => {
      return dispatch(fetchFlowRunSummary(originNodeId, options));
    },
    clearFlowRunSummary: async () => {
      return dispatch(clearFlowRunSummary());
    },
    runFlowNow: async (dataSourceId: string) => {
      return dispatch(runSource(dataSourceId));
    },
  };
};

export type FlowInsightsType = ReturnType<typeof flowInsightsAPI>;
